import { render, staticRenderFns } from "./fdInventory.vue?vue&type=template&id=3a9f12e0"
import script from "./fdInventory.vue?vue&type=script&lang=js"
export * from "./fdInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports